"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isType = void 0;
function isType(subject, validator) {
    return validator ? !!validator(subject) : true;
}
exports.isType = isType;
/**
 * @deprecated use `isType<T>()` or `testType.true<T>()` instead
 */
isType.t = function (subject) {
    return subject === undefined || subject === true;
};
/**
 * @deprecated use `isType<T>()` or `testType.false<T>()` instead
 */
isType.f = function (subject) {
    return subject === undefined || subject === false;
};
function isNever(subject) {
    return true;
}
isType.never = isNever;
/**
 * Are types A and B equals/not equals.
 * Easier to use than `isType.t<>()` and `isType.f<>()`,
 * when doing type level only equality comparison as you don't have to import `Equal<>`.
 *
 * @deprecated use `testType.equal()` instead
 */
isType.equal = function () { };
//# sourceMappingURL=is_type.js.map